/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_External_CodeInputs */

const en_case_field_external_code = /** @type {(inputs: Case_Field_External_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External identifier`)
};

const pt_br2_case_field_external_code = /** @type {(inputs: Case_Field_External_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificador externo`)
};

/**
* | output |
* | --- |
* | "External identifier" |
*
* @param {Case_Field_External_CodeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_external_code = /** @type {((inputs?: Case_Field_External_CodeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_External_CodeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_external_code(inputs)
	return pt_br2_case_field_external_code(inputs)
});